import { ActiveModes, CheckoutContactForm } from '@checkout-v2/const';
import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateWithCustomCheckout } from '../checkout-state';
import { getActiveModes } from './checkout.selector';

export const getContacts: MemoizedSelector<StateWithCustomCheckout, CheckoutContactForm | undefined> = createSelector(
  getActiveModes,
  (activeModes: ActiveModes) => activeModes.contacts,
);
